// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign20Filled: FC<Campaign20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M15 10.75v-1.5h3v1.5h-3Zm.854 5.75-2.458-1.708.875-1.23 2.458 1.709-.875 1.229ZM14.25 6.437l-.854-1.229L15.854 3.5l.854 1.23-2.458 1.707ZM4 16v-4h-.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 2 10.5v-1c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 3.5 8h2.896L11 5.25v9.5L6.52 12H6v4H4Zm8-3.563V7.564c.32.305.566.673.74 1.104a3.534 3.534 0 0 1 0 2.666c-.174.43-.42.799-.74 1.104Z" />
        </svg>
    );
};

export default Campaign20Filled;
